import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/edocai/edocai/app/[lang]/components/Card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/edocai/edocai/app/[lang]/components/Preview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/edocai/edocai/app/[lang]/components/ServicesSection.tsx");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/header.jpg");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/posts/chi-siamo.jpg");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/posts/la-proposta.jpg");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/posts/network.jpg");
